import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import { toJS } from '../../../utils/helper';
import Dashboard from '../../Dashboard';
import { fetchExceptionsRoutine, fetchJobRoutine, resolveExceptionRoutine } from '../../../redux/routines';
import { isDialogVisibleSelector } from '../../../redux/selectors';
import ExceptionsGrid from './ExceptionsGrid';
import ExceptionDialog from './ExceptionDialog';
import { showDialog, hideDialog, showError, showConfirm } from '../../../redux/actions/dialogs';

import { EXCEPTION_DIALOG } from '../../../redux/constants/dialogs';

import styles from './styles';

class ExceptionsReport extends Component {
  componentWillMount() {
    const jobId = this.props.match.params.jobId;
    this.loadData(jobId);
  }

  componentWillReceiveProps(newProps) {
    if (this.props.match.params.jobId !== newProps.match.params.jobId) {
      this.loadData(newProps.match.params.jobId);
    }
  }

  loadData = (jobId) => {
    this.props.fetchJob(jobId);
  };

  handleViewException = (exception) => {
    console.log('handleViewException', exception);
    this.props.showDialog(EXCEPTION_DIALOG, {
      jobId: this.props.match.params.jobId,
      exception
    });
  };

  handleResolveException = (exception) => {
    console.log('handleResolveException', exception);
    return new Promise((resolve, reject) => {
      const message = 'Are you sure you wish to resolve this exception?';
      this.props.showConfirm({
        title: message,
        onConfirm: () => {
          this.props.resolveException({
            jobId: this.props.match.params.jobId,
            exception,
          });
        },
        onReject: reject,
      });
    });
  };

  render() {
    const { job, exceptions, fetchExceptions, match: { params: { jobId } }, isDialogVisible } = this.props;
    const customer = job && job.customer ? job.customer.name : 'Unknown';
    const description = job && job.description ? job.description : '';

    // const activeExceptions = (exceptions || []).filter((exception) => !exception.resolved);

    return (
      <Dashboard title={`Exceptions - ${customer} - ${description}`}>
        <ExceptionsGrid
          data={exceptions}
          fetch={(params) => fetchExceptions(_.assign(params, { jobId }))}
          onViewException={this.handleViewException}
          onResolveException={this.handleResolveException}
        />

        {isDialogVisible(EXCEPTION_DIALOG) ? <ExceptionDialog/> : null}
      </Dashboard>
    );
  }
}

ExceptionsReport.propTypes = {
  fetchJob: PropTypes.func.isRequired,
  fetchExceptions: PropTypes.func.isRequired,
  job: PropTypes.object.isRequired,
  exceptions: PropTypes.object,
  loading: PropTypes.bool,
  match: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  const job = toJS(state.getIn(['jobs', 'job']));
  const exceptions = toJS(state.getIn(['exceptions', 'exceptions']));

  return {
    job,
    exceptions,
    isDialogVisible: isDialogVisibleSelector(state)
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchJob: fetchJobRoutine.trigger,
    fetchExceptions: fetchExceptionsRoutine.trigger,
    resolveException: resolveExceptionRoutine.trigger,

    showDialog,
    hideDialog,
    showError,
    showConfirm,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ExceptionsReport);



// WEBPACK FOOTER //
// ./src/components/Reports/ExceptionsReport/index.js